import { Routes } from '@angular/router';
import { CommerceConfigurationsRouting, ManualSynchronizationRouting } from './app.consts';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
var ɵ0 = function () {
    return import("./commerce-configurations/commerce-configurations.module.ngfactory").then(function (m) { return m.CommerceConfigurationsModuleNgFactory; });
}, ɵ1 = function () {
    return import("./manual-synchronization/manual-synchronization.module.ngfactory").then(function (m) { return m.ManualSynchronizationModuleNgFactory; });
};
var routes = [
    {
        path: CommerceConfigurationsRouting.Root,
        loadChildren: ɵ0,
        runGuardsAndResolvers: 'always',
    },
    {
        path: ManualSynchronizationRouting.Root,
        loadChildren: ɵ1,
    },
    // just as a safty measure. when moving to this state we will log it using status.
    {
        path: '**',
        component: PageNotFoundComponent,
        runGuardsAndResolvers: 'always',
        pathMatch: 'full',
    },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1 };
